var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import raf from 'raf';
var getElementBoundingRectHOC = function (Component) {
    return /** @class */ (function (_super) {
        __extends(HOC, _super);
        function HOC(props) {
            var _this = _super.call(this, props) || this;
            _this.element = null;
            _this.state = {
                bounding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 0,
                    width: 0,
                },
            };
            _this.scrollChanged = _this.scrollChanged.bind(_this);
            return _this;
        }
        HOC.prototype.componentDidMount = function () {
            var _this = this;
            window.addEventListener('scroll', function () { return raf(_this.scrollChanged); });
            this.scrollChanged();
        };
        HOC.prototype.componentWillUnmount = function () {
            window.removeEventListener('scroll', this.scrollChanged);
        };
        HOC.prototype.scrollChanged = function () {
            if (this.element) {
                this.setState({ bounding: this.element.getBoundingClientRect() });
            }
        };
        HOC.prototype.render = function () {
            var _this = this;
            return (React.createElement("div", { className: "elementBounding", ref: function (r) { _this.element = r; } },
                React.createElement(Component, __assign({}, this.props, { elementBounding: this.state.bounding }))));
        };
        return HOC;
    }(React.Component));
};
export default getElementBoundingRectHOC;
//# sourceMappingURL=getElementBoundingRectHOC.js.map